import axios from "axios";
export default {
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async createQuiz( _, formData){
      return await axios.post('/quizzes', formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updateQuiz( _, {id, formData}){
      return await axios.post(`/quizzes/${id}`, formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    }
  },
};
